import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpLoaderService {
  httpLoader = new BehaviorSubject(false);

  show() {
    this.httpLoader.next(true);
  }

  hide() {
    this.httpLoader.next(false);
  }
}
